export default __webpack_public_path__ + "static/media/animation-arrow28.b01a65be.gif";